// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"06a23c82","376":"86b08002","681":"06a23c82"}[chunkId] + ".chunk.css";
};